import validate from "/Users/olivermurphy/Code/spas/justhire/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45old_45urls_45global from "/Users/olivermurphy/Code/spas/justhire/middleware/redirectOldUrls.global.js";
import manifest_45route_45rule from "/Users/olivermurphy/Code/spas/justhire/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirect_45old_45urls_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}